import { useMemo } from 'react';
import { createStaticDataProvider } from '@adv-frontend/data-provider';
import { createFilterSelectWithSuggest, HighlightedText } from '@adv-frontend/filters';
import { DISCOUNT_FILTER_ID } from '#shared/lib/filters';
import { trimAndLowerString } from '#shared/lib/string';
import { useFilterDiscountsTitleByValue } from './hooks/useFilterDiscountsTitleByValue';
import { useGetDiscountsForFilters } from '../api/api';
import { DISCOUNT_FILTER_TITLE } from './constants';

export const createDiscountFilter = () =>
    createFilterSelectWithSuggest<
        string,
        {
            id: string;
            label: string;
        }
    >({
        id: DISCOUNT_FILTER_ID,
        title: DISCOUNT_FILTER_TITLE,
        suggestProps: {
            dataProvider: function Component(props) {
                const searchString = trimAndLowerString(props.queryArg.searchValue);

                const { data } = useGetDiscountsForFilters();

                const mappedData = useMemo(() => {
                    const items: { id: string; label: string }[] = (data || [])
                        .filter(({ title }) => trimAndLowerString(title).includes(searchString))
                        .map(({ id, title }) => {
                            return {
                                id,
                                label: title,
                            };
                        });

                    return items;
                }, [data, searchString]);

                const dataProvider = useMemo(() => createStaticDataProvider(mappedData), [mappedData]);

                return props.children(dataProvider);
            },
            useTitleByValue: useFilterDiscountsTitleByValue,
            renderSelectListItem: ({ item, search }) => <HighlightedText text={item.label} search={search} joinParts />,
            renderFilterChipsItem: ({ item }) => item.label,
        },
    });
